// ManagePasswordForm.tsx
import { Form, Input, Typography } from 'antd';
import {
	LockOutlined,
	KeyOutlined,
	SafetyCertificateOutlined,
	EyeInvisibleOutlined,
	EyeTwoTone,
} from '@ant-design/icons';

const { Text } = Typography;

export const ManagePasswordForm = () => {
	return (
		<div className="space-y-6">
			{/* Old Password Field */}
			<Form.Item
				label={
					<div className="flex items-center">
						<LockOutlined className="mr-2 text-gray-500" />
						<Text>Current Password</Text>
					</div>
				}
				name="oldPassword"
				rules={[
					{
						required: true,
						message: 'Please input your current password!',
					},
				]}
			>
				<Input.Password
					placeholder="Enter your current password"
					className="!rounded-lg"
					size="large"
					iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
				/>
			</Form.Item>

			{/* New Password Field */}
			<Form.Item
				label={
					<div className="flex items-center">
						<KeyOutlined className="mr-2 text-gray-500" />
						<Text>New Password</Text>
					</div>
				}
				name="newPassword"
				rules={[{ required: true, message: 'Please input your new password!' }]}
			>
				<Input.Password
					placeholder="Enter your new password"
					className="!rounded-lg"
					size="large"
					iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
				/>
			</Form.Item>

			{/* Confirm Password Field */}
			<Form.Item
				label={
					<div className="flex items-center">
						<SafetyCertificateOutlined className="mr-2 text-gray-500" />
						<Text>Confirm Password</Text>
					</div>
				}
				name="confirmPassword"
				dependencies={['newPassword']}
				rules={[
					{ required: true, message: 'Please confirm your password!' },
					({ getFieldValue }) => ({
						validator(_, value) {
							if (!value || getFieldValue('newPassword') === value) {
								return Promise.resolve();
							}
							return Promise.reject(new Error('The passwords you entered do not match!'));
						},
					}),
				]}
			>
				<Input.Password
					placeholder="Confirm your new password"
					className="!rounded-lg"
					size="large"
					iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
				/>
			</Form.Item>
		</div>
	);
};
